import { DocumentoArrecadacaoRetificacaoBase1TO } from "src/app/pagamento/models/documento-arrecadacao-retificacao-base1-to";

export const DocumentoArrecadacaoRetificacao_DTO: DocumentoArrecadacaoRetificacaoBase1TO = {
  numeroRegistro: "1036002065",
  numeroDocumento: "12345678901234567890",
  ni: "12345678901234567890",
  dataArrecadacao: new Date().toISOString(),
  dataVencimento: new Date().toISOString(),
  periodoApuracao: "2023-01",
  referencia: "2023-01",
  processo: "1234567890",
  idCEF: "1234567890",
  vrba: 100.00,
  vrbaPercentual: 10.00,
  codigoBanco: "001",
  codigoAgencia: "1234",
  codigoReceita01: "1234",
  codigoReceita02: "5678",
  codigoReceita03: "9101",
  codigoExtensaoReceita01: "0001",
  valorReceita01: 50.00,
  valorReceita02: 30.00,
  valorReceita03: 20.00,
  valorTotal: 100.00,
  tipoDocumento: { codigo: 12, descricao: "tipoDocumento" },
  situacaoDocumento: { codigo: 28, descricao: "situacaoDocumento" },
  tiicCd: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
  idVersao: Math.floor(Math.random() * (999999 - 100000 + 1)) + "",
  isDocumentoNumerado: false,
  isNiInvalido: false,
  isCancelaDocAlocPaex: false,
  isAlteraPABase2: false,
  isAlteradoDocumentoAlocado: false,
  processoAlteracao: "",
  origemErro: "",
  desmembramentos: []
};
